import { Component, EventEmitter, Input, OnInit, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { UtilsService } from 'src/app/utils/utils.service';
import { isNullOrUndefined } from 'util';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DataService } from 'src/app/main/shared/services/data.service';
import { GisDimsMapComponent } from 'src/app/main/shared/gis-dims-map/gis-dims-map.component';

@Component({
  selector: 'app-uv-forecast-sidebar',
  templateUrl: './uv-forecast-sidebar.component.html',
  styleUrls: ['./uv-forecast-sidebar.component.scss']
})
export class UvForecastSidebarComponent implements OnInit, OnDestroy {

  @Input() labelStrings: any;
  @Input() blockNum: number;
  @Output() playPos = new EventEmitter<any>();
  queryParams: any = {};
  isInitialLoad: boolean = false;
  dateIndexLength: any;
  activeRadioList: boolean[] = [];
  destroy: any = new Subject();
  sessionStorage: any = { params: {} };
  selectedForecastLength: any = '24';

  constructor(
    private gisUtils: UtilsService,
    private dataService: DataService,
    private gisMapComp: GisDimsMapComponent
  ) { }

  ngOnInit() {
    this.isInitialLoad = true;
    this.subscribeEvents();
    this.setParams();
  }

  subscribeEvents() {
    this.gisUtils.selectedParams
      .pipe(takeUntil(this.destroy))
      .subscribe((params: any) => {
        const sessionStorageSelectedParams: any = sessionStorage.getItem('params');
        if (Object.keys(params).length > 0) {
          this.queryParams = params;
        } else {
          this.queryParams = sessionStorageSelectedParams ? JSON.parse(sessionStorageSelectedParams) : {};
          this.sessionStorage.params = { ...this.queryParams };
          if (Object.keys(this.queryParams).length) {
            this.gisUtils.setSelectedParams(this.queryParams);
          }
        }
        if (!isNullOrUndefined(this.queryParams) && Object.keys(this.queryParams).length > 0) {
          // Single source of truth for the +24H/+7D mode lives on queryParams.forecastLength,
          // set via the shared app-time-menu-toggle control — mirrored here only to size the play bar.
          this.selectedForecastLength = this.queryParams['forecastLength'] || '24';
          this.dateIndexLength = this.selectedForecastLength === '24' ? 24 : 7;
          this.activeRadioList = [];
          for (let i = 0; i < this.dateIndexLength; ++i) {
            this.activeRadioList.push(i === this.blockNum);
          }
        }
      });
  }

  setParams() {
    if (this.isInitialLoad && !Object.keys(this.sessionStorage.params).length) {
      this.requestSelectedFilterParams();
    }
    this.isInitialLoad = false;
  }

  ngOnChanges(change: SimpleChanges) {
    if (!isNullOrUndefined(change.blockNum) && Object.keys(this.labelStrings).length > 0) {
      if (change.blockNum.currentValue) {
        this.buttonClicked(change.blockNum.currentValue);
      }
    } else {
      this.buttonClicked(this.blockNum);
    }
    this.activeRadioList = [];
    for (let i = 0; i < this.dateIndexLength; ++i) {
      this.activeRadioList.push(i === this.blockNum);
    }
  }

  requestSelectedFilterParams() {
    let currentUrlParams: any = {};
    if (!this.isInitialLoad) {
      currentUrlParams = this.queryParams;
    }
    currentUrlParams['component'] = 'UVFORECAST';
    if (this.isInitialLoad) {
      currentUrlParams['actionType'] = 'filter';
      currentUrlParams['view'] = 'Admin';
      currentUrlParams['pType'] = 'COUNTRY';
      currentUrlParams['cType'] = 'STATE';
      currentUrlParams['parentLoc'] = 'COUNTRY';
      currentUrlParams['dashboardView'] = 'INDIA';
      currentUrlParams['dashboardType'] = 'gis';
      const userLocationConfig = this.dataService.formQuerParamsVariables(
        this.gisMapComp.metaInfo.userDetailsJson.data.location,
        this.gisMapComp.metaInfo.userDetailsJson.data.locType
      );
      const currentLocations: any = userLocationConfig.locationInfo[userLocationConfig.types.pType.toLowerCase()].split('##');
      currentUrlParams['pUUID'] = currentLocations[1];
      currentUrlParams['locName'] = currentLocations[0];
      currentUrlParams['locType'] = userLocationConfig.types.pType;
      currentUrlParams['pEUUID'] = userLocationConfig.locationInfo.country.split('##')[1];
      currentUrlParams['location'] = userLocationConfig.locationInfo.location;
      currentUrlParams['forecastLength'] = '24';
      this.isInitialLoad = false;
    }
    this.gisUtils.setSelectedParams(currentUrlParams);
  }

  buttonClicked(blockNumber, from?: string) {
    if (from === 'HTML') {
      this.playPos.emit(blockNumber);
    }
    if (this.activeRadioList[blockNumber]) {
      this.gisUtils.setIndex(this.labelStrings[blockNumber]['groupName']);
    }
  }

  validate(i) {
    if (this.labelStrings[i] == undefined || this.labelStrings[i] == null) {
      return ""
    }
    else {
      return this.labelStrings[i]['fullLabel'];
    }
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

}
